// All 28 SBS Training Programs
// Each program: { id, lift, frequency, level, displayName, weeks: [{ weekNum, days: [{ dayNum, exercises: [...] }] }] }
// Exercise: { name, percentage?, weight?, sets, reps, isAMAP?, isRPE?, rpeTarget?, notes?, isAccessory? }

const programs = [
  // ===================== BENCH PROGRAMS =====================
  {
    id: 'bench_1x_beg',
    lift: 'bench',
    frequency: '1x',
    level: 'Beginner',
    displayName: 'Bench 1x/week Beginner',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true },
        { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '5' },
        { name: 'Bench Press', percentage: 0.70, sets: 3, reps: '8-10' },
        { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true },
        { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '3' },
        { name: 'Bench Press', percentage: 0.75, sets: 3, reps: '6-8' },
        { name: 'Curls/Pullups/Pulldowns', sets: 4, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.90, sets: 1, reps: 'AMAP', isAMAP: true },
        { name: 'Bench Press', percentage: 0.90, sets: 2, reps: '1' },
        { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '5' },
        { name: 'Curls/Pullups/Pulldowns', sets: 5, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 4, isMaxTest: true, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        { name: 'Curls/Pullups/Pulldowns', sets: 2, reps: '8', isAccessory: true },
      ]}]},
    ]
  },
  {
    id: 'bench_1x_int',
    lift: 'bench',
    frequency: '1x',
    level: 'Intermediate',
    displayName: 'Bench 1x/week Intermediate',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '5' },
        { name: 'Bench Press', percentage: 0.70, sets: 3, reps: '8-10' },
        { name: 'Triceps Extensions', sets: 3, reps: '8', isAccessory: true },
        { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 3, reps: '12', isAccessory: true },
        { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.85, sets: 3, reps: '3' },
        { name: 'Bench Press', percentage: 0.75, sets: 3, reps: '6-8' },
        { name: 'Triceps Extensions', sets: 4, reps: '8', isAccessory: true },
        { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 4, reps: '12', isAccessory: true },
        { name: 'Curls/Pullups/Pulldowns', sets: 4, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.90, sets: 3, reps: '1' },
        { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '5' },
        { name: 'Triceps Extensions', sets: 5, reps: '8', isAccessory: true },
        { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 5, reps: '12', isAccessory: true },
        { name: 'Curls/Pullups/Pulldowns', sets: 5, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 4, isMaxTest: true, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        { name: 'Triceps Extensions', sets: 2, reps: '8', isAccessory: true },
        { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 2, reps: '12', isAccessory: true },
        { name: 'Curls/Pullups/Pulldowns', sets: 2, reps: '8', isAccessory: true },
      ]}]},
    ]
  },
  {
    id: 'bench_1x_adv',
    lift: 'bench',
    frequency: '1x',
    level: 'Advanced',
    displayName: 'Bench 1x/week Advanced',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '5' },
        { name: 'Bench Press', percentage: 0.70, sets: 3, reps: '8-10' },
        { name: 'Pin/Floor Press', weight: '10RM', sets: 1, reps: '10', notes: 'Then EMOM for 10 min or until miss' },
        { name: 'Pin/Floor Press (EMOM)', weight: 'same', sets: 4, reps: '1', notes: 'EMOM for 10 min' },
        { name: 'Triceps Extensions', sets: 3, reps: '8', isAccessory: true },
        { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 3, reps: '12', isAccessory: true },
        { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.85, sets: 3, reps: '3' },
        { name: 'Bench Press', percentage: 0.75, sets: 3, reps: '6-8' },
        { name: 'Pin/Floor Press', weight: '8RM', sets: 1, reps: '8', notes: 'Then EMOM for 10 min or until miss' },
        { name: 'Pin/Floor Press (EMOM)', weight: 'same', sets: 3, reps: '1', notes: 'EMOM for 10 min' },
        { name: 'Triceps Extensions', sets: 4, reps: '8', isAccessory: true },
        { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 4, reps: '12', isAccessory: true },
        { name: 'Curls/Pullups/Pulldowns', sets: 4, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', percentage: 0.90, sets: 3, reps: '1' },
        { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '5' },
        { name: 'Pin/Floor Press', weight: '6RM', sets: 1, reps: '6', notes: 'Then EMOM for 10 min or until miss' },
        { name: 'Pin/Floor Press (EMOM)', weight: 'same', sets: 2, reps: '1', notes: 'EMOM for 10 min' },
        { name: 'Triceps Extensions', sets: 5, reps: '8', isAccessory: true },
        { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 5, reps: '12', isAccessory: true },
        { name: 'Curls/Pullups/Pulldowns', sets: 5, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 4, isMaxTest: true, days: [{ dayNum: 1, exercises: [
        { name: 'Bench Press', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        { name: 'Pin/Floor Press', weight: '3RM', sets: 1, reps: '3' },
        { name: 'Triceps Extensions', sets: 2, reps: '8', isAccessory: true },
        { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 2, reps: '12', isAccessory: true },
        { name: 'Curls', sets: 2, reps: '8', isAccessory: true },
      ]}]},
    ]
  },
  {
    id: 'bench_2x_beg',
    lift: 'bench',
    frequency: '2x',
    level: 'Beginner',
    displayName: 'Bench 2x/week Beginner',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 4, reps: '5' },
          { name: 'Bench Press', percentage: 0.85, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'If >5 reps, auto-adjusted' },
          { name: 'Hammer Curl', sets: 4, reps: '10', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '12RM', sets: 1, reps: '12' },
          { name: 'Close Grip Bench', weight: 'same', sets: 3, reps: '8-10' },
          { name: 'Curls/Pullups/Pulldowns', weight: '15RM', sets: 2, reps: '12-15', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '5' },
          { name: 'Bench Press', percentage: 0.85, sets: 3, reps: '3' },
          { name: 'Bench Press', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'If >5 reps, auto-adjusted' },
          { name: 'Hammer Curl', sets: 3, reps: '10', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '10RM', sets: 1, reps: '10' },
          { name: 'Close Grip Bench', weight: 'same', sets: 4, reps: '6-8' },
          { name: 'Curls/Pullups/Pulldowns', weight: '15RM', sets: 2, reps: '12-15', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 3, reps: '3' },
          { name: 'Bench Press', percentage: 0.90, sets: 2, reps: '1' },
          { name: 'Bench Press', percentage: 0.90, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'If >3 reps, auto-adjusted' },
          { name: 'Hammer Curl', sets: 3, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Close Grip Bench', weight: 'same', sets: 5, reps: '5-6' },
          { name: 'Curls/Pullups/Pulldowns', weight: '15RM', sets: 2, reps: '12-15', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.70, sets: 5, reps: '3' },
          { name: 'Hammer Curl', sets: 3, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
          { name: 'Curls/Pullups/Pulldowns', weight: '15RM', sets: 3, reps: '12-15', isAccessory: true },
        ]},
      ]},
    ]
  },
  {
    id: 'bench_2x_int',
    lift: 'bench',
    frequency: '2x',
    level: 'Intermediate',
    displayName: 'Bench 2x/week Intermediate',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 4, reps: '5' },
          { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '3' },
          { name: 'Triceps Extensions', sets: 4, reps: '8', isAccessory: true },
          { name: 'DB Press', sets: 4, reps: '8', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 4, reps: '10', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '12RM', sets: 1, reps: '12' },
          { name: 'Close Grip Bench', weight: 'same', sets: 3, reps: '8-10' },
          { name: 'Curls (BFR circuit)', weight: '30RM', sets: 2, reps: 'AMAP', isAccessory: true, notes: 'Circuit with blood flow restriction' },
          { name: 'DB Triceps Extensions (BFR)', weight: '30RM', sets: 2, reps: 'AMAP', isAccessory: true },
          { name: 'DB Fly (BFR)', weight: '30RM', sets: 2, reps: 'AMAP', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '5' },
          { name: 'Bench Press', percentage: 0.85, sets: 4, reps: '3' },
          { name: 'Triceps Extensions', sets: 3, reps: '8', isAccessory: true },
          { name: 'DB Press', sets: 3, reps: '8', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '10', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '10RM', sets: 1, reps: '10' },
          { name: 'Close Grip Bench', weight: 'same', sets: 4, reps: '6-8' },
          { name: 'Curls (BFR circuit)', weight: '30RM', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Triceps Extensions (BFR)', weight: '30RM', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Fly (BFR)', weight: '30RM', sets: 3, reps: 'AMAP', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 3, reps: '3' },
          { name: 'Bench Press', percentage: 0.90, sets: 3, reps: '1' },
          { name: 'Triceps Extensions', sets: 3, reps: '6', isAccessory: true },
          { name: 'DB Press', sets: 3, reps: '6', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Close Grip Bench', weight: 'same', sets: 5, reps: '5-6' },
          { name: 'Curls (BFR circuit)', weight: '30RM', sets: 4, reps: 'AMAP', isAccessory: true },
          { name: 'DB Triceps Extensions (BFR)', weight: '30RM', sets: 4, reps: 'AMAP', isAccessory: true },
          { name: 'DB Fly (BFR)', weight: '30RM', sets: 4, reps: 'AMAP', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.70, sets: 5, reps: '3' },
          { name: 'Triceps Extensions', sets: 3, reps: '6', isAccessory: true },
          { name: 'DB Press', sets: 3, reps: '6', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
          { name: 'Curls (no BFR)', weight: '20RM', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Triceps Extensions', weight: '20RM', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Fly', weight: '20RM', sets: 3, reps: 'AMAP', isAccessory: true },
        ]},
      ]},
    ]
  },
  {
    id: 'bench_2x_adv',
    lift: 'bench',
    frequency: '2x',
    level: 'Advanced',
    displayName: 'Bench 2x/week Advanced',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 4, reps: '5' },
          { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '3' },
          { name: 'Weighted Dips', weight: '10RM', sets: 1, reps: '10' },
          { name: 'Weighted Dips', weight: 'same', sets: 3, reps: '8' },
          { name: 'Triceps Extensions', sets: 4, reps: '8', isAccessory: true },
          { name: 'DB Press', sets: 4, reps: '8', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 4, reps: '10', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '12RM', sets: 1, reps: '12' },
          { name: 'Close Grip Bench', weight: 'same', sets: 3, reps: '8-10' },
          { name: 'Bodyweight Pushups', sets: 2, reps: 'AMAP', isAccessory: true },
          { name: 'DB Curl (BFR)', weight: '30RM', sets: 2, reps: 'AMAP', isAccessory: true },
          { name: 'DB Triceps Extensions (BFR)', weight: '30RM', sets: 2, reps: 'AMAP', isAccessory: true },
          { name: 'DB Fly (BFR)', weight: '30RM', sets: 2, reps: 'AMAP', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '5' },
          { name: 'Bench Press', percentage: 0.85, sets: 4, reps: '3' },
          { name: 'Weighted Dips', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Weighted Dips', weight: 'same', sets: 3, reps: '6' },
          { name: 'Triceps Extensions', sets: 3, reps: '8', isAccessory: true },
          { name: 'DB Press', sets: 3, reps: '8', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '10', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '10RM', sets: 1, reps: '10' },
          { name: 'Close Grip Bench', weight: 'same', sets: 4, reps: '6-8' },
          { name: 'Bodyweight Pushups', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Curl (BFR)', weight: '30RM', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Triceps Extensions (BFR)', weight: '30RM', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Fly (BFR)', weight: '30RM', sets: 3, reps: 'AMAP', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 3, reps: '3' },
          { name: 'Bench Press', percentage: 0.90, sets: 3, reps: '1' },
          { name: 'Weighted Dips', weight: '6RM', sets: 1, reps: '6' },
          { name: 'Weighted Dips', weight: 'same', sets: 3, reps: '4-5' },
          { name: 'Triceps Extensions', sets: 3, reps: '6', isAccessory: true },
          { name: 'DB Press', sets: 3, reps: '6', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Close Grip Bench', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Close Grip Bench', weight: 'same', sets: 5, reps: '5-6' },
          { name: 'Bodyweight Pushups', sets: 4, reps: 'AMAP', isAccessory: true },
          { name: 'DB Curl (BFR)', weight: '30RM', sets: 4, reps: 'AMAP', isAccessory: true },
          { name: 'DB Triceps Extensions (BFR)', weight: '30RM', sets: 4, reps: 'AMAP', isAccessory: true },
          { name: 'DB Fly (BFR)', weight: '30RM', sets: 4, reps: 'AMAP', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.70, sets: 5, reps: '3' },
          { name: 'Weighted Dips', weight: '6RM', sets: 3, reps: '3' },
          { name: 'Triceps Extensions', sets: 3, reps: '6', isAccessory: true },
          { name: 'DB Press', sets: 3, reps: '6', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
          { name: 'Bodyweight Pushups', sets: 1, reps: 'AMAP', isAccessory: true },
          { name: 'DB Curl (no BFR)', weight: '20RM', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Triceps Extensions', weight: '20RM', sets: 3, reps: 'AMAP', isAccessory: true },
          { name: 'DB Fly', weight: '20RM', sets: 3, reps: 'AMAP', isAccessory: true },
        ]},
      ]},
    ]
  },
  {
    id: 'bench_3x_beg',
    lift: 'bench',
    frequency: '3x',
    level: 'Beginner',
    displayName: 'Bench 3x/week Beginner',
    hasWeeklyAutoRegulation: true,
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.70, sets: 2, reps: '8' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.75, sets: 2, reps: '6' },
          { name: 'Bench Press', percentage: 0.75, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        ]},
      ]},
      { weekNum: 2, autoRegulate: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.70, sets: 2, reps: '8', notes: 'Weight based on AMAP results from prior week' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: 'AMAP', isAMAP: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.75, sets: 2, reps: '6', notes: 'Weight based on AMAP results from prior week' },
          { name: 'Bench Press', percentage: 0.75, sets: 1, reps: 'AMAP', isAMAP: true },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '4', notes: 'Weight based on AMAP results from prior week' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true },
        ]},
      ]},
    ]
  },
  {
    id: 'bench_3x_int_med',
    lift: 'bench',
    frequency: '3x',
    level: 'Intermediate Medium Volume',
    displayName: 'Bench 3x/week Int. Medium Vol.',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.75, sets: 5, reps: '5' },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 2, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '3' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts based on reps' },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 4, reps: '3' },
          { name: 'Bench Press', percentage: 0.75, sets: 3, reps: '6' },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 2, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 2, reps: '5' },
          { name: 'Bench Press', percentage: 0.75, sets: 2, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '3' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts based on reps' },
          { name: 'Curls/Pullups/Pulldowns', sets: 4, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 4, reps: '3' },
          { name: 'Bench Press', percentage: 0.75, sets: 3, reps: '8' },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 2, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 2, reps: '5' },
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '3' },
          { name: 'Bench Press', percentage: 0.90, sets: 2, reps: '1' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts based on reps' },
          { name: 'Curls/Pullups/Pulldowns', sets: 5, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '2' },
          { name: 'Bench Press', percentage: 0.75, sets: 3, reps: '5' },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '5' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.75, sets: 2, reps: '3' },
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '2' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts based on reps. Or work up to new 1RM' },
          { name: 'Curls/Pullups/Pulldowns', sets: 2, reps: '8', isAccessory: true },
        ]},
      ]},
    ]
  },
  {
    id: 'bench_3x_int_high',
    lift: 'bench',
    frequency: '3x',
    level: 'Intermediate High Volume',
    displayName: 'Bench 3x/week Int. High Vol.',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.75, sets: 5, reps: '5' },
          { name: 'Close Grip Bench', percentage: 0.60, sets: 2, reps: '8' },
          { name: 'Close Grip Bench', percentage: 0.60, sets: 1, reps: 'AMAP', isAMAP: true },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '1' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '3' },
          { name: 'Triceps Extensions', sets: 3, reps: '8', isAccessory: true },
          { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 3, reps: '12', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 4, reps: '3' },
          { name: 'Bench Press', percentage: 0.75, sets: 3, reps: '6' },
          { name: 'Close Grip Bench', percentage: 0.65, sets: 2, reps: '6' },
          { name: 'Close Grip Bench', percentage: 0.65, sets: 1, reps: 'AMAP', isAMAP: true },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '5' },
          { name: 'Bench Press', percentage: 0.75, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '2' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '4' },
          { name: 'Triceps Extensions', sets: 4, reps: '8', isAccessory: true },
          { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 4, reps: '12', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 4, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 4, reps: '3' },
          { name: 'Bench Press', percentage: 0.70, sets: 3, reps: '8' },
          { name: 'Close Grip Bench', percentage: 0.70, sets: 2, reps: '4' },
          { name: 'Close Grip Bench', percentage: 0.70, sets: 1, reps: 'AMAP', isAMAP: true },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '5' },
          { name: 'Bench Press', percentage: 0.75, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '2' },
          { name: 'Bench Press', percentage: 0.90, sets: 2, reps: '1' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 5, reps: '4' },
          { name: 'Triceps Extensions', sets: 5, reps: '8', isAccessory: true },
          { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 5, reps: '12', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 5, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '2' },
          { name: 'Bench Press', percentage: 0.70, sets: 3, reps: '5' },
          { name: 'Close Grip Bench', percentage: 0.75, sets: 3, reps: '3' },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '5' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.75, sets: 2, reps: '3' },
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '2' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts based on reps' },
          { name: 'Triceps Extensions', sets: 2, reps: '8', isAccessory: true },
          { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 2, reps: '12', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 2, reps: '8', isAccessory: true },
        ]},
      ]},
    ]
  },
  {
    id: 'bench_3x_adv',
    lift: 'bench',
    frequency: '3x',
    level: 'Advanced',
    displayName: 'Bench 3x/week Advanced',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.75, sets: 5, reps: '5' },
          { name: 'Close Grip Bench', percentage: 0.60, sets: 2, reps: '8' },
          { name: 'Close Grip Bench', percentage: 0.60, sets: 1, reps: 'AMAP', isAMAP: true },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '1' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '10' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '3' },
          { name: 'Triceps Extensions', sets: 3, reps: '8', isAccessory: true },
          { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 3, reps: '12', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 3, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 4, reps: '3' },
          { name: 'Bench Press', percentage: 0.75, sets: 3, reps: '6' },
          { name: 'Close Grip Bench', percentage: 0.65, sets: 2, reps: '6' },
          { name: 'Close Grip Bench', percentage: 0.65, sets: 1, reps: 'AMAP', isAMAP: true },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '5' },
          { name: 'Bench Press', percentage: 0.75, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '2' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '7' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '10' },
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '12' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '4' },
          { name: 'Triceps Extensions', sets: 4, reps: '8', isAccessory: true },
          { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 4, reps: '12', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 4, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 4, reps: '3' },
          { name: 'Bench Press', percentage: 0.70, sets: 3, reps: '8' },
          { name: 'Close Grip Bench', percentage: 0.70, sets: 2, reps: '4' },
          { name: 'Close Grip Bench', percentage: 0.70, sets: 1, reps: 'AMAP', isAMAP: true },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '5' },
          { name: 'Bench Press', percentage: 0.75, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.80, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.85, sets: 2, reps: '2' },
          { name: 'Bench Press', percentage: 0.90, sets: 2, reps: '1' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 5, reps: '4' },
          { name: 'Triceps Extensions', sets: 5, reps: '8', isAccessory: true },
          { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 5, reps: '12', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 5, reps: '8', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Bench Press', percentage: 0.80, sets: 3, reps: '2' },
          { name: 'Bench Press', percentage: 0.70, sets: 3, reps: '5' },
          { name: 'Close Grip Bench', percentage: 0.75, sets: 3, reps: '3' },
          { name: 'Curls', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '5' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '3' },
          { name: 'Bench Press', percentage: 0.75, sets: 2, reps: '3' },
          { name: 'Bench Press', percentage: 0.80, sets: 2, reps: '2' },
          { name: 'Bench Press', percentage: 0.70, sets: 1, reps: '4' },
          { name: 'Bench Press', percentage: 0.60, sets: 1, reps: '6' },
          { name: 'Bench Press', percentage: 0.50, sets: 1, reps: '8' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Bench Press', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts based on reps' },
          { name: 'Triceps Extensions', sets: 2, reps: '8', isAccessory: true },
          { name: 'DB Press/Flyes/Dips/Pec Dec', sets: 2, reps: '12', isAccessory: true },
          { name: 'Curls/Pullups/Pulldowns', sets: 2, reps: '8', isAccessory: true },
        ]},
      ]},
    ]
  },

  // ===================== SQUAT PROGRAMS =====================
  {
    id: 'squat_1x_beg',
    lift: 'squat',
    frequency: '1x',
    level: 'Beginner',
    displayName: 'Squat 1x/week Beginner',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.75, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        { name: 'Squat', percentage: 0.75, sets: 3, reps: 'AMAP-2', notes: 'Subtract 2 reps from AMAP result' },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        { name: 'Squat', percentage: 0.80, sets: 3, reps: 'AMAP-2', notes: 'Subtract 2 reps from AMAP result' },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        { name: 'Squat', percentage: 0.85, sets: 3, reps: 'AMAP-2', notes: 'Subtract 2 reps from AMAP result' },
      ]}]},
      { weekNum: 4, isMaxTest: true, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        { name: 'Squat', percentage: 0.70, sets: 3, reps: '10' },
      ]}]},
    ]
  },
  {
    id: 'squat_1x_int',
    lift: 'squat',
    frequency: '1x',
    level: 'Intermediate',
    displayName: 'Squat 1x/week Intermediate',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.75, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Shoot for 10+' },
        { name: 'Squat', percentage: 0.75, sets: 5, reps: 'AMAP-2', notes: 'Subtract 2 reps from AMAP' },
        { name: 'Quad Accessory (Leg Press/Lunge/etc.)', sets: 2, reps: '10-12', isAccessory: true },
        { name: 'Hip Thrust/Glute Bridge', sets: 2, reps: '10-12', isAccessory: true },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        { name: 'Squat', percentage: 0.85, sets: 5, reps: 'AMAP-2' },
        { name: 'Quad Accessory (Leg Press/Lunge/etc.)', sets: 3, reps: '10-12', isAccessory: true },
        { name: 'Hip Thrust/Glute Bridge', sets: 3, reps: '10-12', isAccessory: true },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Shoot for 8+' },
        { name: 'Squat', percentage: 0.80, sets: 5, reps: 'AMAP-2' },
        { name: 'Quad Accessory (Leg Press/Lunge/etc.)', sets: 4, reps: '10-12', isAccessory: true },
        { name: 'Hip Thrust/Glute Bridge', sets: 4, reps: '10-12', isAccessory: true },
      ]}]},
      { weekNum: 4, isMaxTest: true, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        { name: 'Squat', percentage: 0.70, sets: 3, reps: '10' },
        { name: 'Quad Accessory', sets: 1, reps: '15-20', isAccessory: true },
        { name: 'Hip Thrust/Glute Bridge', sets: 1, reps: '15-20', isAccessory: true },
      ]}]},
    ]
  },
  {
    id: 'squat_1x_adv',
    lift: 'squat',
    frequency: '1x',
    level: 'Advanced',
    displayName: 'Squat 1x/week Advanced',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.75, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Shoot for 10+' },
        { name: 'Squat', percentage: 0.75, sets: 5, reps: 'AMAP-2', notes: 'Do sets until you can\'t hit target reps. Rest 2min (<180kg) or 3min (>180kg)' },
        { name: 'Quad Accessory (Leg Press/Lunge/etc.)', sets: 3, reps: '10-12', isAccessory: true },
        { name: 'Hip Thrust/Glute Bridge', sets: 3, reps: '10-12', isAccessory: true },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Shoot for 8+' },
        { name: 'Squat', percentage: 0.80, sets: 5, reps: 'AMAP-2' },
        { name: 'Quad Accessory (Leg Press/Lunge/etc.)', sets: 4, reps: '10-12', isAccessory: true },
        { name: 'Hip Thrust/Glute Bridge', sets: 4, reps: '10-12', isAccessory: true },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', percentage: 0.85, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Shoot for 5+' },
        { name: 'Squat', percentage: 0.85, sets: 5, reps: 'AMAP-2' },
        { name: 'Quad Accessory (Leg Press/Lunge/etc.)', sets: 5, reps: '10-12', isAccessory: true },
        { name: 'Hip Thrust/Glute Bridge', sets: 5, reps: '10-12', isAccessory: true },
      ]}]},
      { weekNum: 4, isMaxTest: true, days: [{ dayNum: 1, exercises: [
        { name: 'Squat', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        { name: 'Squat', percentage: 0.70, sets: 3, reps: '10' },
        { name: 'Quad Accessory', sets: 2, reps: '15-20', isAccessory: true },
        { name: 'Hip Thrust/Glute Bridge', sets: 2, reps: '15-20', isAccessory: true },
      ]}]},
    ]
  },
  {
    id: 'squat_2x_beg',
    lift: 'squat',
    frequency: '2x',
    level: 'Beginner',
    displayName: 'Squat 2x/week Beginner',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.75, sets: 6, reps: '6' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Squat', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Squat', weight: 'same', sets: 3, reps: '5-6' },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.80, sets: 5, reps: '5' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Squat', weight: '5RM', sets: 1, reps: '5' },
          { name: 'Squat', weight: 'same', sets: 3, reps: '3-4' },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.85, sets: 3, reps: '1' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Squat', weight: '3RM', sets: 1, reps: '3' },
          { name: 'Squat', weight: 'same', sets: 3, reps: '1-2' },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.70, sets: 3, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Squat', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        ]},
      ]},
    ]
  },
  {
    id: 'squat_2x_int',
    lift: 'squat',
    frequency: '2x',
    level: 'Intermediate',
    displayName: 'Squat 2x/week Intermediate',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.80, sets: 5, reps: '5' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Front Squat', weight: 'same', sets: 3, reps: '5-6' },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.85, sets: 4, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: '5RM', sets: 1, reps: '5' },
          { name: 'Front Squat', weight: 'same', sets: 3, reps: '3-4' },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.90, sets: 3, reps: '1' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: '3RM', sets: 1, reps: '3' },
          { name: 'Front Squat', weight: 'same', sets: 3, reps: '1-2' },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        ]},
      ]},
    ]
  },
  {
    id: 'squat_2x_adv',
    lift: 'squat',
    frequency: '2x',
    level: 'Advanced',
    displayName: 'Squat 2x/week Advanced',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.80, sets: 5, reps: '5' },
          { name: 'Quad Accessory', sets: 3, reps: '10-12', isAccessory: true },
          { name: 'Hip Thrust/Glute Bridge', sets: 3, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Front Squat', weight: 'same', sets: 3, reps: '5-6' },
          { name: 'Wide Stance Paused Squat', weight: '10RM', sets: 1, reps: '10' },
          { name: 'Wide Stance Paused Squat', weight: 'same', sets: 3, reps: '7-8' },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.85, sets: 4, reps: '3' },
          { name: 'Quad Accessory', sets: 4, reps: '10-12', isAccessory: true },
          { name: 'Hip Thrust/Glute Bridge', sets: 4, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: '5RM', sets: 1, reps: '5' },
          { name: 'Front Squat', weight: 'same', sets: 3, reps: '3-4' },
          { name: 'Wide Stance Paused Squat', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Wide Stance Paused Squat', weight: 'same', sets: 3, reps: '5-6' },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.90, sets: 3, reps: '1' },
          { name: 'Quad Accessory', sets: 5, reps: '10-12', isAccessory: true },
          { name: 'Hip Thrust/Glute Bridge', sets: 5, reps: '10-12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: '3RM', sets: 1, reps: '3' },
          { name: 'Front Squat', weight: 'same', sets: 3, reps: '1-2' },
          { name: 'Wide Stance Paused Squat', weight: '5RM', sets: 1, reps: '5' },
          { name: 'Wide Stance Paused Squat', weight: 'same', sets: 3, reps: '3-4' },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
          { name: 'Quad Accessory', sets: 2, reps: '15-20', isAccessory: true },
          { name: 'Hip Thrust/Glute Bridge', sets: 2, reps: '15-20', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
          { name: 'Wide Stance Paused Squat', weight: '10RM', sets: 4, reps: '5' },
        ]},
      ]},
    ]
  },
  {
    id: 'squat_3x_beg',
    lift: 'squat',
    frequency: '3x',
    level: 'Beginner',
    displayName: 'Squat 3x/week Beginner',
    hasWeeklyAutoRegulation: true,
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.70, sets: 2, reps: '8' },
          { name: 'Squat', percentage: 0.70, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Squat', percentage: 0.75, sets: 2, reps: '6' },
          { name: 'Squat', percentage: 0.75, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Squat', percentage: 0.80, sets: 2, reps: '4' },
          { name: 'Squat', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true, notes: 'Auto-adjusts weekly based on reps' },
        ]},
      ]},
      { weekNum: 2, autoRegulate: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Squat', percentage: 0.70, sets: 2, reps: '8', notes: 'Weight based on prior week AMAP' },
          { name: 'Squat', percentage: 0.70, sets: 1, reps: 'AMAP', isAMAP: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Squat', percentage: 0.75, sets: 2, reps: '6', notes: 'Weight based on prior week AMAP' },
          { name: 'Squat', percentage: 0.75, sets: 1, reps: 'AMAP', isAMAP: true },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Squat', percentage: 0.80, sets: 2, reps: '4', notes: 'Weight based on prior week AMAP' },
          { name: 'Squat', percentage: 0.80, sets: 1, reps: 'AMAP', isAMAP: true },
        ]},
      ]},
    ]
  },
  {
    id: 'squat_3x_intadv',
    lift: 'squat',
    frequency: '3x',
    level: 'Intermediate/Advanced',
    displayName: 'Squat 3x/week Int./Adv.',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Low Bar Squat', weight: '10RM', sets: 1, reps: '10' },
          { name: 'Low Bar Squat', weight: 'same', sets: 3, reps: '7-8' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: 'RPE 8', sets: 1, reps: '6', isRPE: true, rpeTarget: 8, notes: 'Work up to heavy set of 6 at RPE 8' },
          { name: 'Front Squat', weight: 'same', sets: null, reps: '6', isRPE: true, rpeTarget: 9, notes: 'Do sets of 6 until RPE 9' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Paused Beltless Olympic Squat', percentage: 0.50, sets: 6, reps: '5', notes: 'Based on low bar belted max' },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Low Bar Squat', weight: '8RM', sets: 1, reps: '8' },
          { name: 'Low Bar Squat', weight: 'same', sets: 3, reps: '5-6' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: 'RPE 8', sets: 1, reps: '4', isRPE: true, rpeTarget: 8, notes: 'Work up to heavy set of 4 at RPE 8' },
          { name: 'Front Squat', weight: 'same', sets: null, reps: '4', isRPE: true, rpeTarget: 9, notes: 'Do sets of 4 until RPE 9' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Paused Beltless Olympic Squat', percentage: 0.55, sets: 6, reps: '4', notes: 'Based on low bar belted max' },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Low Bar Squat', weight: '5RM', sets: 1, reps: '5' },
          { name: 'Low Bar Squat', weight: 'same', sets: 3, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: 'RPE 8', sets: 1, reps: '2', isRPE: true, rpeTarget: 8, notes: 'Work up to heavy set of 2 at RPE 8' },
          { name: 'Front Squat', weight: 'same', sets: null, reps: '2', isRPE: true, rpeTarget: 9, notes: 'Do sets of 2 until RPE 9' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Paused Beltless Olympic Squat', percentage: 0.60, sets: 6, reps: '3', notes: 'Based on low bar belted max' },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Low Bar Squat', weight: '3RM', sets: 1, reps: '3', notes: 'Plug 3RM into rep max calculator, adjust max for next month' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Front Squat', weight: '75% of last week\'s 2RM', sets: 4, reps: '3' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Paused Beltless Olympic Squat', percentage: 0.65, sets: 6, reps: '2', notes: 'Based on low bar belted max' },
        ]},
      ]},
    ]
  },

  // ===================== DEADLIFT PROGRAMS =====================
  {
    id: 'dl_1x_beg',
    lift: 'deadlift',
    frequency: '1x',
    level: 'Beginner',
    displayName: 'Deadlift 1x/week Beginner',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', weight: '10RM', sets: 1, reps: '10', notes: 'Work up slowly with no form breakdown' },
        { name: 'Deadlift (primary stance)', weight: 'same', sets: 3, reps: '5' },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', weight: '8RM', sets: 1, reps: '8', notes: 'Work up slowly with no form breakdown' },
        { name: 'Deadlift (primary stance)', weight: 'same', sets: 3, reps: '4' },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', weight: '5RM', sets: 1, reps: '5', notes: 'Work up slowly with no form breakdown' },
        { name: 'Deadlift (primary stance)', weight: 'same', sets: 3, reps: '2' },
      ]}]},
      { weekNum: 4, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', weight: '3RM', sets: 1, reps: '3', notes: 'Work up slowly. After W4, restart and try to increase weights' },
        { name: 'Deadlift (primary stance)', weight: 'same', sets: 3, reps: '1' },
      ]}]},
    ]
  },
  {
    id: 'dl_1x_int',
    lift: 'deadlift',
    frequency: '1x',
    level: 'Intermediate',
    displayName: 'Deadlift 1x/week Intermediate',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', percentage: 0.80, sets: 4, reps: '5' },
        { name: 'Deadlift (EMOM)', percentage: 0.60, sets: 6, reps: '3', notes: 'EMOM' },
        { name: 'Barbell/DB Rows', sets: 3, reps: '10', isAccessory: true },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', percentage: 0.90, sets: 2, reps: '1' },
        { name: 'Deadlift (primary stance)', percentage: 0.85, sets: 3, reps: '3' },
        { name: 'Deadlift (EMOM)', percentage: 0.65, sets: 6, reps: '3', notes: 'EMOM' },
        { name: 'Barbell/DB Rows', sets: 4, reps: '10', isAccessory: true },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (EMOM)', percentage: 0.70, sets: 6, reps: '3', notes: 'EMOM' },
        { name: 'Barbell/DB Rows', sets: 3, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 4, isMaxTest: true, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
      ]}]},
    ]
  },
  {
    id: 'dl_1x_adv',
    lift: 'deadlift',
    frequency: '1x',
    level: 'Advanced',
    displayName: 'Deadlift 1x/week Advanced',
    weeks: [
      { weekNum: 1, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', percentage: 0.80, sets: 4, reps: '5' },
        { name: 'Deadlift (EMOM)', percentage: 0.60, sets: 6, reps: '3', notes: 'EMOM' },
        { name: 'Deadlift (opposite stance)', weight: 'RPE 8-9', sets: 3, reps: '8', isRPE: true, rpeTarget: 8, notes: 'Last set should be 8-9 RPE' },
        { name: 'Rows', sets: 3, reps: '10', isAccessory: true },
        { name: 'Shrugs', sets: 3, reps: '10', isAccessory: true },
        { name: 'Hip Thrusts', sets: 3, reps: '10', isAccessory: true },
      ]}]},
      { weekNum: 2, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', percentage: 0.90, sets: 2, reps: '1' },
        { name: 'Deadlift (primary stance)', percentage: 0.85, sets: 3, reps: '3' },
        { name: 'Deadlift (EMOM)', percentage: 0.65, sets: 6, reps: '3', notes: 'EMOM' },
        { name: 'Deadlift (opposite stance)', weight: 'RPE 8-9', sets: 3, reps: '6', isRPE: true, rpeTarget: 8 },
        { name: 'Rows', sets: 4, reps: '10', isAccessory: true },
        { name: 'Shrugs', sets: 4, reps: '10', isAccessory: true },
        { name: 'Hip Thrusts', sets: 4, reps: '10', isAccessory: true },
      ]}]},
      { weekNum: 3, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (EMOM)', percentage: 0.70, sets: 6, reps: '3', notes: 'EMOM' },
        { name: 'Deadlift (opposite stance)', weight: 'RPE 8-9', sets: 3, reps: '4', isRPE: true, rpeTarget: 8 },
        { name: 'Rows', sets: 3, reps: '8', isAccessory: true },
        { name: 'Shrugs', sets: 3, reps: '8', isAccessory: true },
        { name: 'Hip Thrusts', sets: 3, reps: '8', isAccessory: true },
      ]}]},
      { weekNum: 4, isMaxTest: true, days: [{ dayNum: 1, exercises: [
        { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
      ]}]},
    ]
  },
  {
    id: 'dl_2x_beg',
    lift: 'deadlift',
    frequency: '2x',
    level: 'Beginner',
    displayName: 'Deadlift 2x/week Beginner',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', weight: 'Heavy 5', sets: 1, reps: '5', notes: 'Work up to a heavy but not max set of 5' },
          { name: 'Deadlift (primary stance)', weight: 'same', sets: 2, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'RPE ~7', sets: 2, reps: '6', notes: '2-3 solid reps in the tank at end of each set' },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', weight: '+2.5-5kg', sets: 1, reps: '5', notes: '2.5-5kg heavier than last week' },
          { name: 'Deadlift (primary stance)', weight: 'same', sets: 3, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'progressive', sets: 3, reps: '6', notes: 'Same weight as W1 for set 1, add 2.5-5kg each set if easy' },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', weight: '+2.5-5kg', sets: 1, reps: '5', notes: '2.5-5kg heavier than last week' },
          { name: 'Deadlift (primary stance)', weight: 'same', sets: 4, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'progressive', sets: 5, reps: '5', notes: 'Same weight as W1 for set 1, add 2.5-5kg each set if easy' },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', weight: '30% lighter', sets: 4, reps: '3', notes: '30% lighter than your top set of 5 from last week' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true, notes: 'New 1RM with no form deviations' },
        ]},
      ]},
    ]
  },
  {
    id: 'dl_2x_int',
    lift: 'deadlift',
    frequency: '2x',
    level: 'Intermediate',
    displayName: 'Deadlift 2x/week Intermediate',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.75, sets: 8, reps: '3' },
          { name: 'RDL', sets: 3, reps: '8', isAccessory: true },
          { name: 'Barbell/DB Rows', sets: 4, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'RPE 8', sets: 3, reps: '6', isRPE: true, rpeTarget: 8, notes: 'First set should be an 8 RPE' },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.80, sets: 6, reps: '3' },
          { name: 'RDL', sets: 4, reps: '8', isAccessory: true },
          { name: 'Barbell/DB Rows', sets: 4, reps: '10', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'same as W1', sets: 4, reps: '6' },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.85, sets: 4, reps: '3' },
          { name: 'RDL', sets: 5, reps: '8', isAccessory: true },
          { name: 'Barbell/DB Rows', sets: 4, reps: '12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'same as W1', sets: 5, reps: '6' },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.65, sets: 4, reps: '3' },
          { name: 'RDL', sets: 2, reps: '8', isAccessory: true },
          { name: 'Barbell/DB Rows', sets: 2, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        ]},
      ]},
    ]
  },
  {
    id: 'dl_2x_adv',
    lift: 'deadlift',
    frequency: '2x',
    level: 'Advanced',
    displayName: 'Deadlift 2x/week Advanced',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.75, sets: 8, reps: '3' },
          { name: 'RDL', sets: 3, reps: '8', isAccessory: true },
          { name: 'Barbell/DB Rows', sets: 4, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'RPE 8', sets: 2, reps: '6', isRPE: true, rpeTarget: 8 },
          { name: 'Rack Pull', percentage: 0.85, sets: 5, reps: '5', notes: 'Bar starts 3-5 inches off the ground. 8-9 RPE' },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.80, sets: 6, reps: '3' },
          { name: 'RDL', sets: 4, reps: '8', isAccessory: true },
          { name: 'Barbell/DB Rows', sets: 4, reps: '10', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'same as W1', sets: 3, reps: '6' },
          { name: 'Rack Pull', percentage: 0.90, sets: 4, reps: '3', notes: 'Bar starts 3-5 inches off the ground. 8-9 RPE' },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.85, sets: 4, reps: '3' },
          { name: 'RDL', sets: 5, reps: '8', isAccessory: true },
          { name: 'Barbell/DB Rows', sets: 4, reps: '12', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (opposite stance)', weight: 'same as W1', sets: 5, reps: '5' },
          { name: 'Rack Pull', percentage: 0.95, sets: 3, reps: '2', notes: 'Bar starts 3-5 inches off the ground. 8-9 RPE' },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.65, sets: 4, reps: '3' },
          { name: 'RDL', sets: 2, reps: '8', isAccessory: true },
          { name: 'Barbell/DB Rows', sets: 2, reps: '8', isAccessory: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        ]},
      ]},
    ]
  },
  {
    id: 'dl_3x_beg',
    lift: 'deadlift',
    frequency: '3x',
    level: 'Beginner',
    displayName: 'Deadlift 3x/week Beginner',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.60, sets: 15, reps: '1' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.70, sets: 10, reps: '1' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.80, sets: 5, reps: '1' },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.65, sets: 15, reps: '1' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.75, sets: 10, reps: '1' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.85, sets: 5, reps: '1' },
        ]},
      ]},
      { weekNum: 3, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.55, sets: 15, reps: '1' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.65, sets: 10, reps: '1' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.90, sets: 1, reps: '1' },
          { name: 'Deadlift (primary stance)', percentage: 0.95, sets: 1, reps: '1' },
          { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true, notes: 'Keep working up to a max. STOP at any form deviation' },
        ]},
      ]},
    ]
  },
  {
    id: 'dl_3x_low',
    lift: 'deadlift',
    frequency: '3x',
    level: 'Lower Volume',
    displayName: 'Deadlift 3x/week Lower Vol.',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.80, sets: 4, reps: '4', notes: 'Terminate each set around 8 RPE' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 10, reps: '1', notes: 'EMOM. If unused to beltless, 50-55% may be more appropriate' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Barbell/DB Rows', sets: 3, reps: '8', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 3, reps: '10', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.85, sets: 3, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 15, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Barbell/DB Rows', sets: 4, reps: '8', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 4, reps: '10', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.90, sets: 2, reps: '1' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 10, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Barbell/DB Rows', sets: 4, reps: '10', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 4, reps: '12', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 20, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Barbell/DB Rows', sets: 5, reps: '10', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 5, reps: '12', isAccessory: true },
        ]},
      ]},
    ]
  },
  {
    id: 'dl_3x_med',
    lift: 'deadlift',
    frequency: '3x',
    level: 'Intermediate Volume',
    displayName: 'Deadlift 3x/week Int. Vol.',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.80, sets: 5, reps: '4' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 15, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (opposite stance)', sets: 2, reps: '6' },
          { name: 'Barbell/DB Rows', sets: 3, reps: '8', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 3, reps: '10', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.85, sets: 4, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 20, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (opposite stance)', sets: 3, reps: '6' },
          { name: 'Barbell/DB Rows', sets: 4, reps: '8', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 4, reps: '10', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.90, sets: 3, reps: '1' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 10, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Barbell/DB Rows', sets: 4, reps: '10', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 4, reps: '12', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 25, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (opposite stance)', sets: 4, reps: '6' },
          { name: 'Barbell/DB Rows', sets: 5, reps: '10', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 5, reps: '12', isAccessory: true },
        ]},
      ]},
    ]
  },
  {
    id: 'dl_3x_high',
    lift: 'deadlift',
    frequency: '3x',
    level: 'Higher Volume',
    displayName: 'Deadlift 3x/week Higher Vol.',
    weeks: [
      { weekNum: 1, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.80, sets: 6, reps: '4' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 20, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (opposite stance)', sets: 3, reps: '6' },
          { name: 'Barbell/DB Rows', sets: 3, reps: '8', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 3, reps: '10', isAccessory: true },
        ]},
      ]},
      { weekNum: 2, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.85, sets: 5, reps: '3' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 25, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (opposite stance)', sets: 4, reps: '6' },
          { name: 'Barbell/DB Rows', sets: 4, reps: '8', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 4, reps: '10', isAccessory: true },
        ]},
      ]},
      { weekNum: 3, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', percentage: 0.90, sets: 4, reps: '1' },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 15, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Barbell/DB Rows', sets: 4, reps: '10', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 4, reps: '12', isAccessory: true },
        ]},
      ]},
      { weekNum: 4, isMaxTest: true, days: [
        { dayNum: 1, exercises: [
          { name: 'Deadlift (primary stance)', weight: 'New 1RM', sets: 1, reps: '1', isMaxTest: true },
        ]},
        { dayNum: 2, exercises: [
          { name: 'Deadlift (beltless)', percentage: 0.60, sets: 30, reps: '1', notes: 'EMOM' },
        ]},
        { dayNum: 3, exercises: [
          { name: 'Deadlift (opposite stance)', sets: 5, reps: '6' },
          { name: 'Barbell/DB Rows', sets: 5, reps: '10', isAccessory: true },
          { name: 'Hip Thrusts/Glute Bridges', sets: 5, reps: '12', isAccessory: true },
        ]},
      ]},
    ]
  },
];

const CUSTOM_PROGRAMS_KEY = 'sbs_custom_programs';

export function getCustomPrograms() {
  try {
    const stored = localStorage.getItem(CUSTOM_PROGRAMS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch { return []; }
}

export function saveCustomProgram(program) {
  const customs = getCustomPrograms();
  const idx = customs.findIndex(p => p.id === program.id);
  if (idx >= 0) customs[idx] = program;
  else customs.push(program);
  localStorage.setItem(CUSTOM_PROGRAMS_KEY, JSON.stringify(customs));
}

export function deleteCustomProgram(id) {
  const customs = getCustomPrograms().filter(p => p.id !== id);
  localStorage.setItem(CUSTOM_PROGRAMS_KEY, JSON.stringify(customs));
}

export function getProgramsByLift(lift) {
  const builtIn = programs.filter(p => p.lift === lift);
  const custom = getCustomPrograms().filter(p => p.lift === lift);
  return [...builtIn, ...custom];
}

export function getProgramById(id) {
  const builtIn = programs.find(p => p.id === id);
  if (builtIn) return builtIn;
  return getCustomPrograms().find(p => p.id === id) || null;
}

export default programs;
